var map = {
	"./": 70,
	"./attachments": 130,
	"./attachments.js": 130,
	"./dialogs": 131,
	"./dialogs.js": 131,
	"./index": 70,
	"./index.js": 70,
	"./messages": 132,
	"./messages.js": 132,
	"./user": 133,
	"./user.js": 133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 199;